import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-gradient-to-br from-sand-50 to-sand-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-navy-800 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('trust.title')} <span className="text-turquoise-500">{t('trust.titleHighlight')}</span>
          </h2>
          <p className="text-lg text-navy-600 max-w-2xl mx-auto">
            {t('trust.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {[
            { icon: 'ri-shield-check-line', titleKey: 'trust.fullyInsured', descKey: 'trust.fullyInsuredDesc' },
            { icon: 'ri-user-star-line', titleKey: 'trust.personalService', descKey: 'trust.personalServiceDesc' },
            { icon: 'ri-tools-line', titleKey: 'trust.wellMaintained', descKey: 'trust.wellMaintainedDesc' },
          ].map((card) => (
            <div key={card.titleKey} className="bg-white rounded-2xl p-8 shadow-lg text-center border border-sand-200 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-turquoise-50 rounded-2xl mb-6 mx-auto">
                <i className={`${card.icon} text-3xl text-turquoise-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-navy-800 mb-4">{t(card.titleKey)}</h3>
              <p className="text-navy-600 leading-relaxed">{t(card.descKey)}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-sand-200 hover:shadow-xl transition-shadow">
            <div className="flex items-start space-x-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-navy-50 rounded-xl flex-shrink-0">
                <i className="ri-compass-3-line text-2xl text-navy-700"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-navy-800 mb-2">{t('trust.localExpertise')}</h3>
                <p className="text-navy-600 leading-relaxed">{t('trust.localExpertiseDesc')}</p>
              </div>
            </div>
            <ul className="space-y-3 ml-16">
              {['trust.secretLocations', 'trust.bestSnorkeling', 'trust.recommendedItineraries'].map((key) => (
                <li key={key} className="flex items-start text-navy-700">
                  <i className="ri-check-line text-turquoise-500 mr-3 mt-1"></i>
                  <span>{t(key)}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-sand-200 hover:shadow-xl transition-shadow">
            <div className="flex items-start space-x-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-coral-50 rounded-xl flex-shrink-0">
                <i className="ri-service-line text-2xl text-coral-500"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-navy-800 mb-2">{t('trust.flexibleOptions')}</h3>
                <p className="text-navy-600 leading-relaxed">{t('trust.flexibleOptionsDesc')}</p>
              </div>
            </div>
            <ul className="space-y-3 ml-16">
              {['trust.skipperAvailable', 'trust.halfOrFull', 'trust.customItineraries'].map((key) => (
                <li key={key} className="flex items-start text-navy-700">
                  <i className="ri-check-line text-turquoise-500 mr-3 mt-1"></i>
                  <span>{t(key)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
